exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-table[data-v-223c380c]{table-layout:inherit}.c-code__heading[data-v-223c380c],th[data-v-223c380c]{font-weight:400;color:#6d6e71}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-223c380c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./demo/ui-kit/phd/phd-links.vue
// module id = 1109
// module chunks = 0